import { gql } from '@apollo/client';

export const ALL_SERVICES = gql`
  query AllServices($input: AllServicesInput) {
    services: allServices(input: $input) {
      aggregate {
        count
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
      edges {
        node {
          id
          name
          description
          startDate
          endDate
          status
          shorthand
          programmes {
            id
            name
          }
          categories {
            id
            name
          }
        }
      }
    }
  }
`;
